<template>
	<div class="form-laundry-container">
		<v-form v-on:submit.prevent="saveProduct">
			<v-layout column>
				<v-flex md4 mb-3>
					<p class="text-xs-left bold" for="laundry-file mb-0">Categoría</p>
					<v-select
						class="filter-select"
						label="Categorías"
						item-text="name"
						item-value="id"
						:items="categories"
						v-model="model.categoryId"
						readonly
						hide-details
						single-line
						bottom>
					</v-select>
				</v-flex>
				<v-flex md4>
					<div class="form-section">
						<p class="text-xs-left bold" for="laundry-file mb-0">Imagen para la prenda</p>
						<file-upload-container v-bind:image-url="model.urlImage"
						  v-on:upload="onUpload" v-bind:label-for="'laundry-file'">
						</file-upload-container>
					</div>
				</v-flex>
				<v-flex md4>
					<div class="form-section">
						<p class="text-xs-left bold mb-1">Nombre de la prenda</p>
						<input type="text" class="input-form" v-model="model.name"
						  placeholder="Nombre de la prenda" />
					</div>
				</v-flex>
				<v-flex md4>
					<div class="form-section">
						<p class="text-xs-left bold mb-1">Precio</p>
						<input
							type="number"
							class="input-form"
							placeholder="0.00"
							step="any"
							v-model.number="model.price" />
					</div>
				</v-flex>
			</v-layout>
			<div class="actions text-xs-left">
				<v-btn
					type="submit"
					:disabled="isDisabled"
					class="btn-save">
					Guardar
				</v-btn>
			</div>
		</v-form>
	</div>
</template>

<script>
import mixin from '@/shared/mixins';
import helper from '@/shared/helper';
import FileUploadContainer from '@/components/shared/FileUpload/FileUploadContainer';

const helperData = helper.data();

function created() {
	this.loadData();
}

async function loadData() {
	const request = [
		this.$http.get(`${process.env.PRODUCTS_URL}/p/categories`),
	];
	if (this.laundryId) {
		const newRequest = this.$http.get(`${process.env.PRODUCTS_URL}/p/products/${this.laundryId}`);
		request.push(newRequest);
	}
	const [categories, laundry] = await Promise.all(request);
	this.categories = categories.data;
	if (laundry) {
		this.model = laundry.data;
	}
	this.model.categoryId = this.categories.find(c => c.code === 'LV').id;
	this.model.type = 2;
}

function onUpload(url) {
	this.model.urlImage = url;
}

async function saveProduct() {
	let dataSend = null;
	if (this.model.urlImage === helperData.preimageUrl) {
		delete this.model.urlImage;
	}
	if (this.laundryId) {
		dataSend = {
			categoryId: this.model.categoryId,
			name: this.model.name,
			price: this.model.price,
			type: this.model.type,
		};
		if (this.model.urlImage) {
			dataSend.urlImage = this.model.urlImage;
		}
	}
	const method = this.laundryId ? 'patch' : 'post';
	const url = this.laundryId ? this.laundryId : 'create';
	const message = this.laundryId ? 'editó' : 'creó';
	const data = this.laundryId ? dataSend : this.model;
	try {
		await this.$http[method](`${process.env.PRODUCTS_URL}/p/products/${url}`, data);
		this.showNotification(`La prenda se ${message} correctamente.`, 'success');
		this.$router.push(this.listHref);
	} catch (err) {
		if (err.status === 400) {
			const error = err.data;
			if (error.message === 'ERR_DEFAULT_CATEGORIES') {
				this.showNotification('Categorías por defecto no agregadas', 'error');
			}
		} else if (err.status === 500) {
			this.showNotification('Ocurrió un error al intentar crear la prenda', 'error');
		}
	}
}

function isDisabled() {
	let disabled = false;
	Object.keys(this.model).forEach((key) => {
		if (key === 'name' || key === 'price') {
			if (!this.model[key]) {
				disabled = true;
			}
		}
	});
	return disabled;
}

export default {
	components: {
		FileUploadContainer,
	},
	computed: {
		isDisabled,
	},
	created,
	data() {
		return {
			categories: [],
			listHref: { name: 'laundry-list' },
			model: {
				categoryId: 0,
				name: '',
				price: null,
				type: 2,
				urlImage: helperData.preimageUrl,
			},
		};
	},
	methods: {
		loadData,
		onUpload,
		saveProduct,
	},
	mixins: mixin,
	name: 'form-laundry',
	props: ['laundryId'],
};
</script>

<style lang="scss" scoped>
.form-section {
	margin-bottom: 24px;
}

.bold {
	font-family: map-get($fonts, medium);
}
</style>





// WEBPACK FOOTER //
// Create.vue?7b2c5ce4